import { makeStyles } from '@mui/styles';
import orange from '../../../../Assets/images/orange.png';
import green from '../../../../Assets/images/green.png';
import black from '../../../../Assets/images/black.png';
import { Theme } from '@mui/material';

export const useStyles = makeStyles((theme: Theme) => ({
  section: {
    padding: '80px 0px',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: '#F5F5F5',
    '@media (max-width: 763px)': {
      padding: '20px 0px',
    },
  },

  cardsContainer: {
    display: 'flex',
    maxWidth: '1500px',
  },

  cardOrange: {
    background: 'linear-gradient(299deg, rgba(255, 138, 5, 0.63) -26.49%, rgba(0, 0, 0, 0.00) 63.83%), #000 !important',
    borderRadius: '12px',
    padding: '40px !important',
    position: 'relative',
    color: '#FFF',
    // removed gridColumn — Flexbox handles the width now
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundImage: `url(${orange})`,
      backgroundRepeat: 'repeat',
      backgroundPosition: 'right bottom',
      borderRadius: '12px',
      zIndex: 1,
    },
    '& > *': {
      position: 'relative',
      zIndex: 2,
    },
    '@media (max-width: 763px)': {
      display: 'flex',
      flexDirection: 'column',
      padding: '20px !important',
    },
  },

  cardGreen: {
    // now participates in equal flex sizing
    flex: 1,

    background: 'linear-gradient(90deg, #0D0D0D 0%, #002F1F 100%)',
    borderRadius: '12px',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    height: '100%',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundImage: `url(${green})`,
      backgroundRepeat: 'no-repeat',
      opacity: 0.2,
      backgroundPosition: 'right bottom',
      borderRadius: '12px',
      zIndex: 1,
    },
    '& > *': {
      position: 'relative',
      zIndex: 2,
    },
    '@media (max-width: 763px)': {
      display: 'flex',
      flexDirection: 'column',
    },
  },

  greenContent: {
    padding: '40px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    flexGrow: 1,
    height: '100%',
    '@media (max-width: 763px)': {
      padding: '20px',
    },
  },

  cardBlack: {
    // now participates in equal flex sizing
    flex: 1,

    background: 'linear-gradient(299deg, rgba(255, 255, 255, 0.50) -26.49%, rgba(0, 0, 0, 0.00) 63.83%), #000',
    borderRadius: '12px',
    padding: '40px',
    color: '#FFF',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundImage: `url(${black})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'right bottom',
      borderRadius: '12px',
      zIndex: 1,
    },
    '& > *': {
      position: 'relative',
      zIndex: 2,
    },
    '@media (max-width: 763px)': {
      display: 'flex',
      flexDirection: 'column',
      padding: '20px',
    },
  },

  orangeHeading: {
    fontSize: '36px !important',
    fontWeight: '700 !important',
    fontFamily: 'Onest, sans-serif',
    lineHeight: '117% !important',
    textTransform: 'capitalize',
    background: 'linear-gradient(90deg, #E8E8E8 0%, #F28C6A 100%)',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    color: '#FFF',
    marginBottom: '16px !important',
    '@media (max-width: 1200px)': {
      width: '80%',
      fontSize: '24px !important',
      fontWeight: '600 !important',
      lineHeight: '2rem !important',
    },
  },

  greenHeading: {
    width: '75%',
    fontSize: '36px !important',
    fontWeight: '700 !important',
    fontFamily: 'Onest, sans-serif',
    lineHeight: '117% !important',
    background: 'linear-gradient(90deg, #E8E8E8 0%, #28BF27 100%)',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    color: '#FFF',
    marginBottom: '6px !important',
    '@media (max-width: 1200px)': {
      width: '80%',
      fontSize: '24px !important',
      fontWeight: '600 !important',
      lineHeight: '2rem !important',
    },
  },

  greenSubtext: {
    width: '100%',
    fontSize: '16px',
    fontFamily: 'Onest, sans-serif',
    fontWeight: '400',
    fontStyle: 'normal',
    lineHeight: 'normal',
    color: '#BBB',
    marginBottom: '12px !important',
    '@media (max-width: 1200px)': {
      fontSize: '12px',
    },
  },

  blackHeading: {
    width: '65%',
    fontSize: '36px !important',
    fontWeight: '700 !important',
    fontFamily: 'Onest, sans-serif',
    lineHeight: '117% !important',
    textTransform: 'capitalize',
    background: 'linear-gradient(90deg, #E8E8E8 0%, #000000 140%)',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    color: '#FFF',
    marginBottom: '6px !important',
    '@media (max-width: 1200px)': {
      width: '80%',
      fontSize: '24px !important',
      fontWeight: '600 !important',
      lineHeight: '2rem !important',
    },
  },

  cardText: {
    width: '80%',
    fontSize: '16px',
    fontFamily: 'Onest, sans-serif',
    fontWeight: '400',
    fontStyle: 'normal',
    lineHeight: 'normal',
    marginTop: '14px !important',
    color: '#BBB',
    '@media (max-width: 1200px)': {
      fontSize: '12px',
    },
    '@media (max-width: 763px)': {
      marginBottom: '32px !important',
      width: '100%',
    },
  },

  cardTextBlack: {
    width: '30vw',
    fontSize: '16px',
    fontFamily: 'Onest, sans-serif',
    fontWeight: '400',
    fontStyle: 'normal',
    lineHeight: 'normal',
    color: '#BBB',
    '@media (max-width: 1200px)': {
      fontSize: '12px',
      width: '100%',
    },
  },

  ctaBtn: {
    display: 'flex',
    maxWidth: '279px',
    bottom: 0,
    background: 'linear-gradient(180deg, rgba(55, 38, 18, 0.00) -175%, rgba(255, 133, 11, 0.50) 140%), #B73601',
    backgroundColor: 'rgba(183, 54, 1, 1) !important',
    padding: '12px 24px !important',
    fontSize: '14px !important',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    marginTop: '24px !important',
    borderRadius: '12px !important',
    border: '1px solid #FFF',
    boxShadow: '0px 1px 2px 0px #FA854D, 0px 0px 0px 3px rgba(255, 181, 114, 0.16)',
    color: 'rgba(255, 255, 255, 1) !important',
    '@media (max-width: 1200px)': {
      fontSize: '12px !important',
      borderRadius: '9px !important',
    },
    '@media (max-width: 763px)': {
      fontSize: '10px !important',
      padding: '8px 6px !important',
      width: '60%',
      maxWidth: '500px',
      borderRadius: '8px !important',
    },
  },

  ghostBtn: {
    display: 'flex',
    background: 'linear-gradient(180deg, rgba(55, 38, 18, 0.00) -175%, rgba(255, 133, 11, 0.50) 140%), #B73601',
    padding: '6px 24px !important',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '14px !important',
    gap: '8px',
    borderRadius: '12px !important',
    border: '1px solid #FFF',
    boxShadow: '0px 1px 2px 0px #FA854D, 0px 0px 0px 3px rgba(255, 181, 114, 0.16)',
    color: 'rgba(255, 255, 255, 1) !important',
    '@media (max-width: 1200px)': {
      fontSize: '12px !important',
    },
    '@media (max-width: 763px)': {
      display: 'none !important',
    },
  },

  greenBtnGroup: {
    display: 'flex',
    gap: '12px',
    marginTop: '16px',
    '@media (max-width: 763px)': {
      gap: '0px',
      justifyContent: 'start',
    },
  },

  tagsWrapper: {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',
    margin: '16px 0px',
  },

  tag: {
    background: 'var(--Colors-Secondary-02-Alpha-10, rgba(40, 191, 39, 0.10))',
    padding: '4px 10px',
    borderRadius: '30px',
    border: '1px solid  #166A16',
    fontSize: '12px',
    color: '#7EFFA3',
  },

  logoContainer1: {
    position: 'absolute',
    top: '24px',
    right: '24px',
    borderRadius: '12px',
    background: 'linear-gradient(293deg, rgba(11, 74, 40, 0.2) 9.56%,rgba(144, 42, 1, 0.53) 86.28%)',
    border: '0.187px solid #681F01',
    display: 'flex',
    padding: '12px 24px !important',
    alignItems: 'center',
    justifyContent: 'center',
    '@media (max-width: 763px)': {
      position: 'relative',
      top: 0,
      right: 0,
      width: '20%',
      marginBottom: '20px !important',
    },
  },

  logoContainer2: {
    position: 'absolute',
    top: '24px',
    right: '24px',
    borderRadius: '12px',
    border: '0.187px solid #316E34',
    background: 'linear-gradient(293deg, rgba(11, 74, 40, 0.0) 9.56%, rgba(49, 110, 52, 0.53) 86.28%)',
    display: 'flex',
    padding: '18px 24px !important',
    alignItems: 'center',
    justifyContent: 'center',
    '@media (max-width: 763px)': {
      position: 'relative',
      top: 0,
      right: 0,
      width: '20%',
      marginBottom: '20px !important',
    },
  },

  logoContainer3: {
    position: 'absolute',
    top: '24px',
    right: '24px',
    borderRadius: '12px',
    border: '0.187px solid  #7C7C7C',
    background: 'linear-gradient(293deg, rgba(11, 14, 74, 0.15) 9.56%, rgba(58, 58, 58, 0.53) 86.28%)',
    display: 'flex',
    padding: '18px 24px !important',
    alignItems: 'center',
    justifyContent: 'center',
    '@media (max-width: 763px)': {
      position: 'relative',
      top: 0,
      right: 0,
      width: '20%',
      marginBottom: '20px !important',
    },
  },

  logoTopRight: {
    height: '40px',
    width: 'auto',
    '@media (max-width: 1200px)': {
      height: '30px',
    },
  },
}));
